import {
    MASTER_SkillDETAILS_REQUEST, MASTER_SkillDETAILS_FAIL, MASTER_SkillDETAILS_SUCCESS,
    MASTER_DEPARTMENT_REQUEST, MASTER_DEPARTMENT_SUCCESS, MASTER_DEPARTMENT_FAIL,
    MASTER_DESIGNATION_REQUEST, MASTER_DESIGNATION_SUCCESS, MASTER_DESIGNATION_FAIL

} from "../constants/AuthConstant"; 
import axios from "axios";

const baseUrl = process.env.REACT_APP_API_PATH

export const fetchSkillDetails = () => async (dispatch) => {
    dispatch({ type: MASTER_SkillDETAILS_REQUEST });
    try {
        const response = await axios(`${baseUrl}/skill/get_all_Skills?pageNumber=-1&pageSize=-1&search=`);
        const data = await response.data;
        dispatch({
            type: MASTER_SkillDETAILS_SUCCESS,
            result: data,
            msg: 'Skills fetched successfully'
        });
    } catch (error) {
        dispatch({
            type: MASTER_SkillDETAILS_FAIL,
            error: error.message,
            msg: 'Failed to fetch skills'
        });
    }
};


export const fetchDepartmentDetails = () => async (dispatch) => {
    dispatch({ type: MASTER_DEPARTMENT_REQUEST });
    try {
        const response = await axios(`${baseUrl}/department/get_all_department?pageNumber=-1&pageSize=-1&search=`);
        const data = await response.data;
        dispatch({
            type: MASTER_DEPARTMENT_SUCCESS,
            result: data,
            msg: 'Skills fetched successfully'
        });
    } catch (error) {
        dispatch({
            type: MASTER_DEPARTMENT_FAIL,
            error: error.message,
            msg: 'Failed to fetch skills'
        });
    }
};


export const fetchDesignationDetails = () => async (dispatch) => {
    dispatch({ type: MASTER_DESIGNATION_REQUEST });
    try {
        const response = await axios(`${baseUrl}/designation/get_all_designation?pageNumber=-1&pageSize=-1&search=`);
        const data = await response.data;
        dispatch({
            type: MASTER_DESIGNATION_SUCCESS,
            result: data,
            msg: 'Skills fetched successfully'
        });
    } catch (error) {
        dispatch({
            type: MASTER_DESIGNATION_FAIL,
            error: error.message,
            msg: 'Failed to fetch skills'
        });
    }
};
